export default __webpack_public_path__ + "db1aa8bd81c6606fb8b0e32157f31253.jpg";